import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import ProductState from "./ProductState";

export default class ProductSelector {
  private readonly element: HTMLSelectElement;

  public constructor(element: HTMLSelectElement) {
    this.element = element;
    element.addEventListener("change", () => this.send(this.element.value));
    Events.on("product-state-change", (state: ProductState) => this.selectElement(state.product.code));
  }

  public send(data: string): void {
    Events.fire("product-changed", data);
  }

  public selectElement(valueToSelect: string) {
    this.element.setAttribute("value", valueToSelect);
  }

  public static Factory: DomFactory<ProductSelector> = (e) => new ProductSelector(e as HTMLSelectElement);
}
